import { configureStore } from '@reduxjs/toolkit';
import settingsSlice from './settingsSlice';
import authUserSlice from './authUserSlice';
import wishlistProductsSlice from './wishlistSlice';
import cartProductsSlice from './cartSlice';
import notificationsSlice from './notificationsSlice';

export const store = configureStore({
  reducer: {
    authUser: authUserSlice,
    settings: settingsSlice,
    wishlist: wishlistProductsSlice,
    cart: cartProductsSlice,
    notifications: notificationsSlice,
  },
});


export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
